export default "<m-cube\n    color=\"yellow\"\n    y=\"2\"\n    width=\"3\"\n    height=\"4\"\n    depth=\"2\"\n></m-cube>\n";